import {z} from "zod";

export const imageSchema = z.object({
    id: z.uuid(),
    fileName: z.string().optional(),
    width: z.number(),
    height: z.number(),
});
